
import Vue, { PropType } from "vue";
import Vuetify, {
  VDialog,
  VIcon,
  VBtn,
  VCard,
  VToolbar,
  VToolbarTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VDivider
} from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

// 出勤意思確認（スマートフォン専用画面）向けの確認・案内ダイアログ。
// 管理画面全体で共用している $confirm / $info とは別に、
// スマートフォンでの視認性を優先して文字を大きくしたダイアログを用意する。
export default Vue.extend({
  name: "IntentionMessageDialog",
  vuetify: new Vuetify(),
  components: {
    VDialog,
    VIcon,
    VBtn,
    VCard,
    VToolbar,
    VToolbarTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VDivider
  },
  props: {
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "出勤意思確認"
    },
    mode: {
      type: String as PropType<"confirm" | "info">,
      default: "info"
    },
    resolve: {
      type: Function as PropType<(value: boolean) => void>,
      required: true
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    ok() {
      this.resolve(true);
      this.destroy();
    },
    cancel() {
      this.resolve(false);
      this.destroy();
    },
    destroy() {
      this.isActive = false;
      // 即座にdomを削除するとtransitionする前に消えてしまうので、200ms待つ
      setTimeout(() => {
        if (document.body.contains(this.$el)) {
          document.body.removeChild(this.$el);
        }
        this.$destroy();
      }, 200);
    }
  },
  created() {
    const el = document.createElement("div");
    document.body.appendChild(el);
    this.$mount(el);
    this.isActive = true;
  }
});
